module.exports = __webpack_public_path__ + "static/media/Pokeball_remix.77f34d17.svg";